<template>
  <div class="cp-search-select">
    <span class="cp-search-select__label">{{filterText}} :</span>
    <v-select  @input="change" :options="Object.values(this.filterList[0])" :clearable="false"  :searchable="false" :placeholder="this.options[0]"   />
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
export default {
  components: {
    vSelect
  },
  props: {
    query: {
      type: [String, Number],
      required: true,
    },
    filterText: {
      type: String,
      required: false
    },
    filterList: {
      type: [Array, Object],
      required: true,
    },
    baseUrl: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      options: Object.values(this.filterList[0]),
      selected: "",
    }
  },

  methods: {
    async change(e) {
      const selectedCode = e;
      const key = Object.keys(this.filterList[0]).find(key => this.filterList[0][key] === selectedCode);
      this.selected = key;
      const lang = document.documentElement.lang
      const ApiUrL = this.baseUrl + "search?term=";
      try {
        if(this.query){
          const data = await axios.get(
              ApiUrL + this.query + "&page=1&filter=" + this.selected  + '&lang_current=' + lang
          ); // + '&lang=' + lang
          this.$emit('list', data.data)
          this.$emit('filterSelected', this.selected)
         // if(data.data.length === 0) this.$emit('noResult', true)
          this.$emit('totalPage', data.data.totalpages)
          if(data.data.total > 0){
            data.data.total = data.data.total;
          }else{
            data.data.total = 0;
          }
          this.$emit('totalResult', data.data.total)
          this.$emit('pageNum', 1)
        }
      } catch (error) {
        return error;
      }

    }
  },
};
</script>
